import styled from "styled-components";

// Libraries
import { Grid } from "@libraries/mui";

const Container = styled.div`
  width: 100%;
`;

const DashboardContainer = styled(Grid)`
  //display: flex;
  //flex-direction: row;
  //align-items: center;
  width: 100%;
  padding: 20px;
`;

const WidgetContainer = styled(Grid)`
  width: 100%;
  padding-bottom: 25px;
  padding-left: 27px !important;
`;

const DashboardIconsContainer = styled(Grid)`
  padding-left: 28px !important;
`;

const DashboardIconsContent = styled(Grid)`
  margin-bottom: 12px;
`;

const DashboardIconsItem = styled(Grid)``;

const LogotipoContainer = styled.div`
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export {
  Container,
  WidgetContainer,
  DashboardContainer,
  DashboardIconsContainer,
  DashboardIconsContent,
  DashboardIconsItem,
  LogotipoContainer
};
